import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import OnlineApplicationMerchant from '@sunbit-dev/common/models/IOnlineApplicationMerchant';
import { RootState } from '~/store/store';
import { getRelativeGetStore } from '~/store/utils';
import { State } from './models';

const initialState: State = {
  merchant: undefined,
  isCreatingApplication: false,
};

export const intro = createSlice({
  name: 'intro',
  initialState,
  reducers: {
    setMerchant: (state, action: PayloadAction<OnlineApplicationMerchant>) => {
      state.merchant = action.payload;
    },
    setIsCreatingApplication: (state, action: PayloadAction<boolean>) => {
      state.isCreatingApplication = action.payload;
    },
  },
});

export const getStore = getRelativeGetStore<Partial<State>>((store: RootState) => store.intro);

export const { setMerchant, setIsCreatingApplication } = intro.actions;

export default intro.reducer;
